import { ReactElement, useEffect } from 'react';

/**
 * NavigationScroll - A component that scrolls the window to the top
 * whenever the route changes. Wrap this around components that should
 * start with the window scrolled to the top.
 */
const NavigationScroll = ({ children }: { children: ReactElement | null }) => {
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.scrollTo) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    } catch (error) {
      // Silently handle scroll errors
      console.warn('Failed to scroll to top:', error);
    }
  }, []);

  return children || null;
};

export default NavigationScroll;
